const single_sign_on = {
    forbidden_domains: 'パブリックメールドメインは許可されていません。',
    duplicated_domains: '重複するドメインがあります。',
    invalid_domain_format: 'ドメインの形式が無効です。',
    duplicate_connector_name: 'コネクタ名が既に存在します。別の名前を選択してください。',
};
export default Object.freeze(single_sign_on);
